<template>
  <InterfaceCard
      icon="mdi-email-outline"
      title="Настройка рассылки"
  >
    <v-checkbox
        v-model="permissions.birthdayGreeting"
        class="mb-0"
        hide-details
        label="Получать поздравления от группы"
        :disabled="disableChange"
        @change="updatePermissions('birthdayGreeting')"
    ></v-checkbox>

    <div class="description primary--text ml-8">
      Данный тип рассылки позволит группе поздравлять Вас с днем рождения и предлагать специальные условия по
      этому поводу.
    </div>

    <v-checkbox
        v-model="permissions.group"
        class="mb-0"
        hide-details
        label="Получать новости группы"
        :disabled="disableChange"
        @change="updatePermissions('group')"
    ></v-checkbox>

    <div class="description primary--text ml-8">
      Данный тип рассылки позволит Вам быть в курсе всех событий группы, а именно:
      <ul>
        <li>актуальные акции;</li>
        <li>скидки;</li>
        <li>изменения списка точек выдачи их адресов;</li>
        <li>любых других изменений в работе группы.</li>
      </ul>
    </div>

    <div v-if="!onlyGroupPermission">
      <v-checkbox
          v-model="permissions.buyoutUpdate"
          class="mb-0"
          hide-details
          label="Получать оповещения об изменениях закупок"
          :disabled="disableChange"
          @change="updatePermissions('buyoutUpdate')"
      ></v-checkbox>

      <div class="description primary--text ml-8">
        Данный тип рассылки позволит Вам следить за изменениями закупок, в которых вы участвуете. Например:
        организатор изменил статус закупки (был <b>"Готовится к выдаче"</b>, стал <b>"Выдача"</b>), а Вы мгновенно
        об этом узнаете с помощью ВК сообщения от группы, в которой открыта закупка ;)
      </div>

      <v-checkbox
          v-model="permissions.buyoutPayment"
          class="mb-0"
          hide-details
          label="Получать оповещение о выставлении счета"
          :disabled="disableChange"
          @change="updatePermissions('buyoutPayment')"
      ></v-checkbox>

      <div class="description primary--text ml-8">
        Даный тип рассылки позволит организатору закупок в которых вы участвуете, быстро сообщить вам о
        выставлении счета, его сумме и позициях, а также срокам и способам оплаты.
        <div class="warn red--text">
          !!!Важно!!! Отключение этого типа рассылки затруднит участие в Совместных Покупках (Общение с организаторами)
        </div>
      </div>

      <v-checkbox
          v-model="permissions.buyoutDelivery"
          class="mb-0"
          hide-details
          label="Получать оповещение о выдаче заказа"
          :disabled="disableChange"
          @change="updatePermissions('buyoutDelivery')"
      ></v-checkbox>

      <div class="description primary--text ml-8">
        Даный тип рассылки позволит организатору закупок в которых вы участвуете, быстро сообщить вам подробности
        о выдаче вашего заказа, а именно где и в какое время его забрать.
        <div class="warn red--text">
          !!!Важно!!! Отключение этого типа рассылки затруднит участие в Совместных Покупках (в частности общение с организаторами)
        </div>
      </div>
    </div>

    <Info
        v-if="error"
        error="error"
    ></Info>
  </InterfaceCard>
</template>

<script>
import Info from '@/components/Info'
import InterfaceCard from '@/components/InterfaceCard'
import {checkSourceIsDemo} from '@/composables/context'
import {getUser} from '@/composables/user'
export default {
  name: 'MessagePermissions',
  components: {Info, InterfaceCard},
  data () {
    return {
      disableChange: false,
      error: null,
      onlyGroupPermission: getUser().data.context && checkSourceIsDemo(getUser().data.context.source_id),
      permissions: getUser().data.message.permissions
    }
  },
  methods: {
    updatePermissions (field) {
      this.disableChange = true
      this.error = null
      this.$client.post(this.$API.DELIVERY.MESSAGE.PERMISSIONS.SETUP, {permissions: this.permissions})
          .catch(err => {
            this.permissions[field] = !this.permissions[field]
            this.error = err.error
          })
          .finally(() => this.disableChange = false)
    }
  }
}
</script>

<style scoped lang="scss">
.description {
  font-size: 14px;
  font-style: italic;
  line-height: 1.2;
  margin: 0.5rem 0;

  .warn {
    font-weight: bold;
    margin: 5px 0;
  }

  ul {
    margin-block-start: 0.5rem;
    margin-block-end: 0.5rem;
  }
}
</style>